<template>
  <ReportToolBelt type="edit" />

  <div class="editor-container">
    <v-sheet class="d-flex" v-if="mode">
      <v-row style="position: relative">
        <v-col cols="9">
          <draggable
              class="section_list"
              v-model="report_data.section_list"
              v-bind="dragOptions"
              group="sections"
              @start="drag=true"
              @end="drag=false"
              item-key="id">
            <template #item="{element, id}">
              <SectionElement :list="element" :id="id" />
            </template>
          </draggable>
        </v-col>
        <v-col cols="3">
          <RightColumn />
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet v-if="!mode">
      <v-navigation-drawer permanent location="end">
        <v-list-item title="ОТВЕТСТВЕННЫЕ ЛИЦА" class="text-center" />
        <v-divider class="ma-0" />
        <v-sheet class="pa-2">
          <v-text-field class="mb-1" variant="plain" v-model="report_data.report_agreement" density="compact" hide-details label="Согласовал" />
          <v-text-field class="mb-1" variant="plain" v-model="report_data.report_author" density="compact" hide-details label="Автор" />
          <v-text-field class="mb-1" variant="plain" v-model="report_data.report_accept" density="compact" hide-details label="Утвердил" />
          <v-text-field class="mb-1" variant="plain" v-model="report_data.report_check" density="compact" hide-details label="Проверил" />
        </v-sheet>
        <v-divider class="ma-0" />
          <v-list-item title="НАВИГАТОР" class="text-center" />
        <v-divider class="ma-0" />
        <div v-for="section in report_data.section_list" :key="section" class="my-section">
          <p style="font-size: 12px; text-align: center; font-weight: bolder">{{ section.name }}</p>
          <div v-for="group in section.groups" :key="group">
            <div class="d-flex">
              <v-spacer />
              <p style="font-size: 10px; color: #b0b0b0">Стр. {{group.page}}</p>
            </div>
            <div v-for="report in group.reports" :key="report" style="cursor: pointer">
              <v-sheet style="font-size: 10px;" class="report-href" v-on:click="goTo(`report_${group.guid}_${report.report_guid}`)">
                {{ report.report_description }}
                <span v-if="CheckObject(report)">{{ report.report_data.length > 0 && report.report_data[0] && Object.keys(report.report_data[0]).includes('ФизОбъектПРЕДСТАВЛЕНИЕ') ? report.report_data[0]['ФизОбъектПРЕДСТАВЛЕНИЕ'] : null }}</span>
              </v-sheet>
            </div>
          </div>
        </div>
      </v-navigation-drawer>

      <ViewerElement v-for="section in report_data.section_list" :section="section" :key="section" />
    </v-sheet>
    <Dialog v-if="dialog" />
  </div>
</template>

<script>
import { ReportData } from "@/store/report/ReportData";
import draggable from 'vuedraggable'
import ViewerElement from "@/components/Reports/ViewerElement";
import { CurrentData, CurrentDialog } from "@/store/report/CurrentDialogData";
import Dialog from "@/components/Reports/Dialog";
import { Rep_Edite_Mode } from "@/store/report/SmallStorrage";
import SectionElement from "@/components/Reports/Editor__Tool/DragBlocks/SectionElement";
import RightColumn from "@/components/Reports/Editor__Tool/RightColumn.vue";
import ReportToolBelt from "@/components/Reports/ReportToolbelt.vue";
import { ScrollOffsetStore } from "@/store/ScrollOffsetStore";

export default {
  name: "editorView",
  components: {
    ReportToolBelt,
    RightColumn,
    SectionElement,
    Dialog,
    draggable,
    ViewerElement
  },
  beforeMount() {
    this.recalculateSpace()
    this.recalculatePages()
  },
  watch: {

  },
  data() {
    return {
      drag: false,
      isSticky: false
    }
  },
  methods: {
    generateDescriptionString: function (reports) {
      // Проверяем сколько будет записок скомбинированно
      let count = 0
      for (let report of reports) {
        if (report.description_note) {
          count++
        }
      }
      let note = ''
      switch (count) {
        case 0:
          return false;
        case 1:
          return reports[0].description_note
        case 2:
        case 3:
          for (let [index, report] of reports.entries()) {
            note+=`Пояснительная записка к ${index+1} графику:\n`
            note+=report.description_note
          }
          return note
      }
    },
    getPattern: function(reports) {
      let description = this.generateDescriptionString(reports)
      let legend = {
        status: false,
        position: null
      }
      for (let [index, report] of reports.entries()) {
        let tmp = this.$rep_cfg.charts.find(chart => chart.guid === report.report_guid)
        if (tmp.legend) {
          legend = {
            status: true,
            position: index
          }
        }
      }
      switch (reports.length) {
        case 0:
          return 'empty'
        case 1:
          if (this.$rep_cfg.patterns.find(pattern => pattern.name === 'multipage').charts.includes(reports[0].report_guid)) {
            return 'multipage_empty'
          } else if (legend.status === true && description === true) {
            return 'single_legend-note'
          } else if (legend.status === true && description === false) {
            return 'single_legend'
          } else if (legend.status === false && description === true) {
            return 'single_note'
          } else {
            return 'single_empty'
          }
        case 2:
          if (legend.status === true && description === true) {
            return 'double_legend-note'
          } else if (legend.status === true && description === false) {
            return 'double_legend'
          } else if (legend.status === false && description === true) {
            return 'double_note'
          } else {
            return 'double_empty'
          }
        case 3:
          if (description === true) {
            return 'triple_note'
          } else {
            return 'triple_empty'
          }
      }
    },
    CheckObject: function (element) {
      const chart = this.$rep_cfg.charts.find(el => el.guid === element['report_guid'])
      if (chart && chart.has_objects) return true
      return false
    },
    recalculateSpace: function () {
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          group.reports.forEach((report) => {
            group.availableSpace = this.$rep_cfg.charts.find(el => el.guid === report.report_guid)
            if (group.availableSpace) {
              group.availableSpace = 3 - group.availableSpace.needSpace
            } else {
              group.availableSpace = 0
            }
          })
        })
      })
    },
    recalculatePages: function () {
      let page = 1
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          group.page = page
          page++
        })
      })
    },
    goTo: function (id) {
      let body = document.body.getBoundingClientRect()
      let element = document.getElementById(id).getBoundingClientRect()
      let offset = (element.top - body.top) - 90
      window.scrollTo({
        top: offset,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  computed: {
    offset: {
      set(value) {
        ScrollOffsetStore().set(value)
      },
      get() {
        return ScrollOffsetStore().get()
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "sections",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    mode: {
      get() {
        return Rep_Edite_Mode().get()
      },
      set(value) {
        return Rep_Edite_Mode().set(value)
      }
    },
    dialog: {
      get() {
        return CurrentDialog().get()
      },
      set(value) {
        CurrentDialog().set(value)
      }
    },
    current: {
      get() {
        return CurrentData().get()
      },
      set(value) {
        CurrentData().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  }
}
</script>

<style scoped>
.report-href {
  border-radius: 5px;
  border: 1px dotted #cccccc;
  background: #eeeeee;
  color: #3a3a3a;
  padding-left: 5px;
  margin: 1px;
  transition: 0.1s;
}
.report-href:hover {
  background: #3a3a3a;
  color: #eeeeee;
}

.my-page {
  border-radius: 5px;
  border: 1px dotted #dcdcdc;
  padding: 1px;
  margin-bottom: 1px;
  width: 600px;
  aspect-ratio: 297 / 210 !important;
}

.my-section {
  border-radius: 5px;
  padding: 2px;
  background: #ffffff;
  margin-bottom: 10px;
}
</style>
